/**
 * Meta events we send a server-side copy of, by Meta event name.
 *
 * Deliberately narrower than everything `getFacebookEvent` maps. An event on
 * this list carries its deduplication id, Meta cookies and hashed identifiers
 * all the way through Firehose into the warehouse, so adding a high-volume
 * event here costs storage on every row and queue and API throughput per event.
 *
 * `PageView` is on the list despite being the highest-volume event by an order
 * of magnitude, because Landing Page View optimisation is driven by it and
 * campaigns do run against that objective. A page load the pixel never reports
 * — a blocked pixel, a failed script, a restrictive browser — is a landing page
 * view Meta cannot count, and the server copy is what recovers it.
 *
 * `ViewContent` and `Search` stay off it. They are comparably frequent but no
 * campaign objective optimises against them, so forwarding them would buy
 * warehouse rows and API calls and nothing else. The browser pixel still
 * reports both.
 */
const SERVER_FORWARDED_EVENTS = new Set([
    'PageView',
    'EnquirySubmit',
    'EnquiryReveal',
    'EnquiryEngagement',
    'PhoneReveal',
    'BookConsultationReveal',
    'HDESubmission',
    'WebsiteReferral',
    'Targeted_WebsiteReferral',
    'FileDownload',
    'Save',
    'AddToCart',
    'InitiateCheckout',
    'Purchase',
]);

/**
 * Whether this Meta event should also be reported from the server.
 */
export function isServerForwardedEvent(metaEventName: string): boolean {
    return SERVER_FORWARDED_EVENTS.has(metaEventName);
}
